gsap.registerPlugin(ScrollTrigger)

window.addEventListener("DOMContentLoaded", () => {

    /* LENIS SMOOTH SCROLL (OPTIONAL) */
    lenis = new Lenis({
        autoRaf: true,
    })
    /* LIENIS SMOOTH SCROLL (OPTIONAL) */


    const container = document.querySelector('.mwg_effect001 .container')
    const cardsContainer = container.querySelector('.cards')
    const cards = document.querySelectorAll('.card')
    const distance = cardsContainer.clientWidth - window.innerWidth
    
    gsap.to('.scroll', {
        autoAlpha:0,
        duration:0.2,
        scrollTrigger: {
            trigger: cardsContainer,
            start:'top top',
            end:'top top-=1',
            toggleActions: "play none reverse none"
        }
    })

    const scrollTween = gsap.to(cardsContainer, {
        x: - distance,
        ease: 'none', // linear progression
        // let's pin our container while our cardsContainer is animating
        scrollTrigger: {
            trigger: container,
            pin: true,
            scrub: true, // progress with the scroll
            start: 'top top',
            end: '+=' + distance
        }
    });

    cards.forEach(card => {
        const values = {
            // get a value between 30 and 50 or -30 and -50
            x: (Math.random() * 20 + 30) * (Math.random() < 0.5 ? 1 : -1),
            // get a value between 10 and 16 or -16 and -10
            y: (Math.random() * 6 + 10) * (Math.random() < 0.5 ? 1 : -1),
            // get a value between 10 and 20 or -10 and -20
            rotation: (Math.random() * 10 + 10) * (Math.random() < 0.5 ? 1 : -1)
        };

        gsap.fromTo(card, {
            // let's start from this 3 values
            rotation: values.rotation,
            xPercent: values.x,
            yPercent: values.y
        }, {
            // and finish to its 3 opposite values
            rotation: - values.rotation,
            xPercent: - values.x,
            yPercent: - values.y,
            ease: 'none', // linear progression
            scrollTrigger:{
                trigger:card,
                containerAnimation: scrollTween, // our tween will listen to our scrollTween container position
                start:'left 120%' ,
                end:'right -20%',
                scrub:true, // the animation progress with the scroll
            }
        })
    })
})

gsap.registerPlugin(ScrollTrigger)

window.addEventListener("DOMContentLoaded", () => {

    /* LENIS SMOOTH SCROLL (OPTIONAL) */
    lenis = new Lenis({
        autoRaf: true,
    })
    /* LIENIS SMOOTH SCROLL (OPTIONAL) */

    gsap.to('.scroll', {
        autoAlpha:0,
        duration:0.2,
        scrollTrigger: {
            trigger:'.mwg_effect005',
            start:'top top',
            end:'top top-=1',
            toggleActions: "play none reverse none"
        }
    })

    const paragraph = document.querySelector(".mwg_effect005 .paragraph")
    wrapWordsInSpan(paragraph)

    const pinHeight = document.querySelector(".mwg_effect005 .pin-height")
    const container = document.querySelector(".mwg_effect005 .container")
    const words = document.querySelectorAll(".mwg_effect005 .word")

    gsap.to(words, {
        x: 0, // Animate the 'x' property to 0
        stagger: 0.02, // Stagger the animation of each element by 0.02 seconds
        ease: 'power4.inOut', // Use a power4 easing function for smooth start and end
        scrollTrigger: {
            trigger: pinHeight, // We listen to pinHeight position
            start: 'top top', // Start the animation when the top of the trigger hits the top of the viewport
            end: 'bottom bottom', // End the animation when the bottom of the trigger hits the bottom of the viewport
            scrub: true, // Smoothly scrub the animation based on scroll position
            pin: container, // Let's pin our container while all the words animate
        }
    })
})

// UTIL METHOD
function wrapWordsInSpan(element) {
    const text = element.textContent;
    element.innerHTML = text
        .split(' ')
        .map(word => `<span class="word">${word}</span>`)
        .join(' ');
}

gsap.registerPlugin(ScrollTrigger)

window.addEventListener("DOMContentLoaded", () => {

    const lenis = new Lenis({
        orientation: 'horizontal', // Horizontal scroll
        infinite: true, // Infinite repeat
        autoRaf: true
    })

    // Updates all ScrollTrigger instances on scroll
    lenis.on('scroll', ScrollTrigger.update)

    // Forces the scroll position to the very beginning
    lenis.scrollTo(0, {
        immediate: true,
    })
    
    document.querySelectorAll('.mwg_effect047 .media').forEach(el => {
        // Image appearance
        gsap.fromTo(el.querySelector('img'), {
            transformOrigin: '0% 50%' // Starting from the left edge
        }, {
            transformOrigin: '0% 50%',
            scaleX: 1, // Returning to initial width
            ease: 'none', // Linear movement
            scrollTrigger: {
                horizontal: true,
                trigger: el, // Listen to the image position
                start: 'left 100%', // Starts when the left edge of the image is on the right side of the viewport
                end: 'left 80%', // Ends when the left edge of the image is at 80% of the viewport
                scrub: true, // Progresses with the scroll
            }
        })
        
        // Disappearance of the image
        gsap.fromTo(el.querySelector('img'), {
            transformOrigin: '100% 50%'
        }, {
            transformOrigin: '100% 50%',
            scaleX: 0, // Squashing the image
            ease: 'none', // Linear movement
            immediateRender: false, // To avoid tween conflicts
            scrollTrigger: {
                horizontal: true,
                trigger: el, // Listen to the image position
                start: 'right 20%', // Starts when the right edge of the image is at 20% of the viewport
                end: 'right 0%', // Ends when the right edge of the image is at 0% of the viewport
                scrub: true, // Progresses with the scroll
            }
        })
    })
})



// Effect 08
gsap.registerPlugin(Observer)

let total = 0,
    xTo,
    itemValues = []

window.addEventListener("DOMContentLoaded", () => {

    const content = document.querySelector('.mwg_effect008 .container')
    const cards = document.querySelectorAll('.mwg_effect008 .card')
    const cardsLength = cards.length / 2
    const half = content.clientWidth / 2

    const wrap = gsap.utils.wrap(-half, 0);

    xTo = gsap.quickTo(content, "x", {
        duration: 0.5, // Will transition over 0.5s
        ease: 'power3', // Non-linear
        modifiers: {
            x: gsap.utils.unitize(wrap),
        },
    });

    // Generate an array of random values between -10 and 10
    for (let i = 0; i < cardsLength; i++) {
        itemValues.push((Math.random() - 0.5) * 20);
    }

    // Create a GSAP timeline and keep it paused initially
    const tl = gsap.timeline({ paused: true });
    tl.to(cards, {
        // Rotate each card using a precomputed random value
        rotate: (index) => (itemValues[index % cardsLength]),
        // Move each card horizontally based on the same random value
        xPercent: (index) => (itemValues[index % cardsLength]),
        // Move each card vertically based on the same random value
        yPercent: (index) => (itemValues[index % cardsLength]),
        // Slightly scale down the cards
        scale: 0.95,
        duration: 0.5,
        ease: 'back.inOut(3)', // Non-linear
    })

    Observer.create({
        target: content,
        type: "pointer,touch", // Detect both pointer and touch events
        onPress: () => tl.play(), // Play the timeline when pressing down
        onDrag: (self) => { // Update the horizontal position while dragging
            total += self.deltaX
            xTo(total)
        },
        onRelease: () => { // Reverse the timeline when releasing the pointer
            tl.reverse()
        },
        onStop: () => { // Reverse the timeline when the interaction stops
            tl.reverse()
        },
    })

    gsap.ticker.add(tick);

    // TO GO FURTHER: You can add an offscreen check and kill Observer when necessary
});

function tick(time, deltaTime) {
    total -= deltaTime / 10  // Adjust the speed of automatic scrolling    
    xTo(total)
}